import type { ReactNode } from 'react'

import Icon, { type IconTypes } from '@components/utils/Icon'

type EmbedEmptyStateProps = {
  headingLevel: 2 | 3
  icon: IconTypes
  title: string
  children: ReactNode
  action?: ReactNode
}

export function EmbedEmptyState({ headingLevel, icon, title, children, action }: EmbedEmptyStateProps) {
  const Heading = `h${headingLevel}` as const
  return (
    <div className="tw:flex tw:flex-col tw:items-center tw:gap-3 tw:rounded-(--embed-radius,1rem) tw:border tw:border-dashed tw:border-gray-300 tw:bg-white tw:px-6 tw:py-10 tw:text-center">
      <span className="tw:flex tw:h-12 tw:w-12 tw:items-center tw:justify-center tw:rounded-full tw:bg-gray-100">
        <Icon type={icon} className="tw:h-6 tw:w-6 tw:text-gray-500" />
      </span>
      <Heading className="tw:text-base tw:font-semibold tw:text-gray-900">{title}</Heading>
      <div className="tw:flex tw:max-w-md tw:flex-col tw:gap-1 tw:text-sm tw:text-gray-600">{children}</div>
      {action && <div className="tw:flex tw:flex-wrap tw:justify-center tw:gap-2">{action}</div>}
    </div>
  )
}
